type ImageBoxProps = {
  label?: string;
  className?: string;
  rounded?: string;
};

/** Neutral placeholder standing in for artwork that will be supplied later. */
export function ImageBox({ label = "[Image]", className = "", rounded = "rounded-2xl" }: ImageBoxProps) {
  return (
    <div
      className={`flex items-center justify-center bg-muted text-xs font-medium text-muted-foreground ${rounded} ${className}`}
    >
      {label}
    </div>
  );
}
